module.exports = __webpack_public_path__ + "static/media/CRC.5982ad91.svg";